import { useContext, useEffect, useState } from 'react';

import QueryString from 'query-string';
import { useLocation, useParams } from 'react-router';

import Loading from '../../../Components/Loading/Loading';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { getMedal, getRank } from '../../../Utils/Helpers';
import { IDCardContext } from '../Context/IDCardContext';

const Show = () => {
  const { competitionId, userId } = useParams();
  const { search } = useLocation();
  const { get } = useApi();
  const { error } = useToast();
  const [loading, setLoading] = useState(true);
  const context = useContext(IDCardContext);
  const queryParams = QueryString.parse(search);

  useEffect(() => {
    const getData = async () => {
      if (queryParams?.type != undefined && queryParams?.type == 'rank') {
        await getRankApi();
      }
      await getCompetition();
      await getUser();
    };
    getData();
  }, [competitionId, userId]);

  const getRankApi = async () => {
    setLoading(true);
    await get(
      `/sport_rule/rank/competition/${competitionId}/user/${userId}?sport_id=${queryParams?.sport_id}&weight_id=${queryParams?.weight}`,
      (res) => {
        context.userRank = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا مواجه شد.');
        setLoading(false);
      },
    );
  };

  const getCompetition = async () => {
    setLoading(true);
    await get(
      `/competition/${competitionId}`,
      (res) => {
        context.competition = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا مواجه شد.');
        setLoading(false);
      },
    );
  };

  const getUser = async () => {
    setLoading(true);
    await get(
      `/user/${userId}/with-insurance`,
      (res) => {
        setLoading(false);
        context.user = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا مواجه شد.');
        setLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master
      containerFullWidth={true}
      headerFixed={true}
      showSidebar={false}
      title='مشخصات شرکت کننده'
    >
      <div
        className='w-100 bg-dark-mode-3 d-flex flex-column vh-100'
        style={{ fontFamily: 'iransans' }}
      >
        <div className='d-flex flex-row border-top pt-2 bg-purple justify-content-between'>
          <div className='d-flex flex-row'>
            <i className='fad fa-calendar-check f-20 mx-2 text-dark-mode'></i>
            <h1 className='f-13 font-weight-bold text-dark-mode mt-1'>
              نمایش اطلاعات
            </h1>
          </div>
        </div>
        <div className='row mx-2 overflow-auto'>
          <div className='col-12'>
            <div className='form-group w-100 my-2 d-flex flex-column align-items-center justify-content-center'>
              <label className='my-2 text-dark-mode'>عکس پرسنلی</label>
              <img
                className='img-thumbnail'
                src={context.user?.personnel_image ?? ''}
                style={{ width: '120px', height: '120px' }}
                alt=''
              />
            </div>
          </div>

          <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <div className='form-group'>
              <label className='my-2 text-dark-mode'>نام</label>
              <input
                type='text'
                disabled
                className='form-control'
                value={context.user?.name}
              />
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <div className='form-group'>
              <label className='my-2 text-dark-mode'>نام خانوادگی</label>
              <input
                type='text'
                disabled
                className='form-control'
                value={context.user?.last_name}
              />
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <div className='form-group'>
              <label className='my-2 text-dark-mode'>کد ملی</label>
              <input
                type='text'
                disabled
                className='form-control'
                value={context.user?.national_card_id}
              />
            </div>
          </div>

          <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <div className='form-group'>
              <label className='my-2 text-dark-mode'>موبایل</label>
              <input
                type='text'
                disabled
                className='form-control'
                value={context.user?.mobile}
              />
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <div className='form-group'>
              <label className='my-2 text-dark-mode'>استان</label>
              <input
                type='text'
                disabled
                className='form-control'
                value={context.user?.province_living?.name}
              />
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <div className='form-group'>
              <label className='my-2 text-dark-mode'>تاریخ پایان بیمه</label>
              <input
                type='text'
                disabled
                className='form-control'
                value={context.user?.insurance?.end_date}
              />
            </div>
          </div>
          {queryParams?.type == 'rank' && (
            <>
              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <div className='form-group'>
                  <label className='my-2 text-dark-mode'>مقام</label>
                  <input
                    type='text'
                    disabled
                    className='form-control'
                    value={getRank(context.userRank?.rank)}
                  />
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <div className='form-group'>
                  <label className='my-2 text-dark-mode'>نشان</label>
                  <input
                    type='text'
                    disabled
                    className='form-control'
                    value={getMedal(context.userRank?.rank)}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </Master>
  );
};

export default Show;
